import actions from "actions";
import ActionTypes from "actions/ActionTypes";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { createLoadingSelector } from "reducers/selectors";
import { bindActionCreators, Dispatch } from "redux";
import { useHistory, useLocation } from "react-router-dom";
import { Container } from "reactstrap";
import { StoreManagerProps } from "./type";
import StoreListing from "./container/StoreListing";
import t from "utils/Lang";

const loadingSelector = createLoadingSelector([
  ActionTypes.STORE_STATISTIC_PREFIX,
]);

const breadDefault = { label: t().store_listing__store, path: "/store" };

const initialStatistic: any = null;

const StoreManager = ({
  setBreadcrumbs,
  loading,
  storeStatistic,
}: StoreManagerProps) => {
  const location = useLocation();
  const history = useHistory();
  const [currentStatistic, setCurrentStatistic] = useState(initialStatistic);
  useEffect(() => {
    setBreadcrumbs([breadDefault]);
  }, []);
  useEffect(() => {
    const status = location.search.split("=")?.[1];
    updateBreadcrumbs(status);
    setCurrentStatistic(status);
  }, [location]);
  const updateBreadcrumbs = (status: string) => {
    const statistic = storeStatistic?.find((s) => s.id.toString() == status);
    if (statistic) {
      const breads = [breadDefault];
      breads.push({
        label: statistic?.name,
        path: `/store?status=${status}`,
      });
      setBreadcrumbs(breads);
    }
  };
  const onChangeStatus = (status: string) => {
    if (status) history.push(`/store?status=${status}`);
  };
  const onStoreClick = (store: any) => {
    const breads = [breadDefault];
    const statistic = storeStatistic?.find(
      (s) => s.id.toString() == currentStatistic
    );
    if (statistic) {
      breads.push({
        label: statistic?.name,
        path: `/store?status=${currentStatistic}`,
      });
    }
    breads.push({
      label: store?.name || "Chưa có tên",
      path: `/store/${store.id}`,
    });
    setBreadcrumbs(breads);
    history.push(`/store/${store.id}`);
  };
  return (
    <Container style={{ paddingTop: 10 }}>
      <StoreListing
        storeStatistic={storeStatistic}
        status={currentStatistic}
        onChangeStatus={onChangeStatus}
        onStoreClick={onStoreClick}
      />
    </Container>
  );
};

const mapStateToProps = (state: any) => {
  return {
    loading: loadingSelector(state),
    storeStatistic: state.store.storeStatistic,
  };
};

const mapActionsToProps = (dispatch: Dispatch) =>
  bindActionCreators(actions, dispatch);

export default connect(mapStateToProps, mapActionsToProps)(StoreManager);
